












































































































































































































































import Vue from "vue";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import { GET_COMPANY_DETAILS } from "@/store/modules/auth/constants";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { UPLOAD_FILES } from "@/store/modules/common/constants";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import { UPDATE_COMPANY_DETAILS } from "@/store/modules/recruiter/constants";
export default Vue.extend({
  name: "EditCompanyDetails",
  components: {
    GoBackHeader
  },
  data() {
    return {
      company_name: "",
      company_website: "",
      company_location: "",
      company_description: "",
      links: {
        instagram: "",
        facebook: "",
        linkedin: "",
        twitter: "",
        images: {
          cover: {
            s3Link: "",
            location: ""
          },
          profile: { s3Link: "", location: "" }
        }
      },
      valid_data: false,
      required_rule: [(value: string) => !!value || "Field is required"],
      image: "profile",
      profile: null as string | null | undefined | ArrayBuffer,
      cover: null as string | null | undefined | ArrayBuffer,
      profile_file: null as File | null,
      cover_file: null as File | null,
      loading: false
    };
  },
  computed: {
    ...mapGetters("auth", {
      get_company_details: GET_COMPANY_DETAILS
    })
  },
  created() {
    if (this.get_company_details) {
      this.company_name = this.get_company_details.public_name || "";
      this.company_website = this.get_company_details.company_website || "";
      this.company_location = this.get_company_details.company_location || "";
      this.company_description =
        this.get_company_details.company_description || "";
      this.links = {
        instagram: this.get_company_details.links?.instagram || "",
        facebook: this.get_company_details.links?.facebook || "",
        linkedin: this.get_company_details.links?.linkedin || "",
        twitter: this.get_company_details.links?.twitter || "",
        images: this.get_company_details.links?.images || {
          cover: { s3Link: "", location: "" },
          profile: { s3Link: "", location: "" }
        }
      };
    }
  },
  methods: {
    ...mapActions("common", {
      upload_files: UPLOAD_FILES
    }),
    ...mapActions("recruiter", {
      update_company_detail: UPDATE_COMPANY_DETAILS
    }),
    ...mapActions("auth", {
      get_companies_details: GET_COMPANY_DETAILS
    }),
    ...mapMutations({
      root_error: ROOT_ERROR,
      root_notification: ROOT_NOTIFICATION
    }),
    async submit_details() {
      this.loading = true;
      if ((this.$refs.edit_form as any).validate()) {
        const obj = new FormData();
        obj.append("path", `images/${this.company_name}`);
        if (this.cover_file) {
          obj.append("file", this.cover_file);
          const response = await this.upload_files(obj);
          if (response) {
            this.links.images.cover = response[0];
          }
        }
        const obj1 = new FormData();
        obj1.append("path", `images/${this.company_name}`);
        if (this.profile_file) {
          obj1.append("file", this.profile_file);
          const response = await this.upload_files(obj1);
          if (response) {
            this.links.images.profile = response[0];
          }
        }

        const response = await this.update_company_detail({
          company_name: this.company_name,
          company_website: this.company_website,
          company_location: this.company_location,
          company_description: this.company_description,
          links: {
            instagram: this.links.instagram,
            facebook: this.links.facebook,
            linkedin: this.links.linkedin,
            twitter: this.links.twitter,
            images: {
              cover: this.links.images.cover,
              profile: this.links.images.profile
            }
          }
        });
        if (response) {
          this.root_notification("Company details updated successfully");
          this.get_companies_details();
          this.$router.push({ name: "company-profile" });
        } else {
          this.root_error("Failed to update company details");
        }
      }
      this.loading = false;
    },
    upload_profile() {
      this.image = "profile";
      const file_uploader = this.$refs.profile_input as any;
      file_uploader.$refs.input.click();
    },
    upload_cover() {
      this.image = "cover";
      const file_uploader = this.$refs.cover_input as any;
      file_uploader.$refs.input.click();
    },
    process_selected_file(file: File) {
      this.image === "profile"
        ? (this.profile_file = file)
        : (this.cover_file = file);
      this.validate_resume_type_and_size();
    },
    validate_resume_type_and_size() {
      const file =
        this.image === "profile" ? this.profile_file : this.cover_file;
      if (file) {
        if (
          !(
            (file.size <= 1048576 && file.type === "image/png") ||
            file.type === "image/jpeg" ||
            file.type === "image/jpg"
          )
        ) {
          this.root_error("Invalid file type or size");
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            if (this.image === "profile") this.profile = e?.target?.result;
            else if (this.image === "cover") this.cover = e?.target?.result;
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }
});
